import apiClient from '../../api/http-common';

const getProfileSettingsOptions = () =>
  apiClient.post('/profile/get-settings-data')

const generateQrCodeForFarmer = () =>
  apiClient.post('/profile/devices/generate-qr-code')

const getProfileSettingsQrCode = () =>
  apiClient.post('/profile/generate-qr-code')

const enableGoogleAuth = (data) =>
  apiClient.post('/profile/enable-google-2fa', data)

const disableGoogleAuth = (data) =>
  apiClient.post('/profile/disable-google-2fa', data)

const checkPassword = (data) =>
  apiClient.post('/profile/check-password', data)

const sendMobileConfirmationCode = () =>
  apiClient.post('/profile/send-mobile-confirmation-code')

const confirmMobileCode = (data) =>
  apiClient.post('/profile/confirm-mobile', data)

const disableSms = (data) =>
  apiClient.post('/profile/disable-sms-2fa', data)

const enableSms = (data) =>
  apiClient.post('/profile/enable-sms-2fa', data)

const sendSmsCode = () =>
  apiClient.post('/profile/send-sms-code')

const updatePassword = (data) =>
  apiClient.post('/profile/password-update', data)

const sendCode = () =>
  apiClient.post('/profile/send-code')

const checkCode = (data) =>
  apiClient.post('/profile/check-code', data)

const ProfileSettingsService = {
  getProfileSettingsOptions,
  getProfileSettingsQrCode,
  enableGoogleAuth,
  disableGoogleAuth,
  checkPassword,
  sendMobileConfirmationCode,
  confirmMobileCode,
  disableSms,
  enableSms,
  sendSmsCode,
  updatePassword,
  sendCode,
  checkCode,
  generateQrCodeForFarmer
};

export default ProfileSettingsService;
